import type { Playlist, PlaylistItem } from '../../types/playlist';
import type { DurationAbbreviation } from '../../types/i18n';

import { formatDuration, formatLocalizedDateShort, formatVideoScheduleTime } from './formatting';

export const isString = function (input: unknown): input is string {
  return !!input && typeof input === 'string';
};

export const createVideoMetadata = (media: PlaylistItem, i18n: DurationAbbreviation & { episodesLabel?: string; seasonsLabel?: string }) => {
  const metaData = [];
  const duration = formatDuration(media.duration, i18n);

  if (media.pubdate) metaData.push(String(new Date(media.pubdate * 1000).getFullYear()));
  if (!i18n.episodesLabel && !i18n.seasonsLabel && duration) metaData.push(duration);
  if (i18n.episodesLabel) metaData.push(i18n.episodesLabel);
  if (i18n.seasonsLabel) metaData.push(i18n.seasonsLabel);
  if (media.genre) metaData.push(media.genre.split(',').join(', '));
  if (media.rating) metaData.push(media.rating);

  return metaData;
};
export const createPlaylistMetadata = (playlist: Playlist, episodesLabel?: string) => {
  const metaData = [];

  if (episodesLabel) metaData.push(episodesLabel);
  if (isString(playlist.genre)) metaData.push(playlist.genre.split(',').join(', '));
  if (isString(playlist.rating)) metaData.push(playlist.rating);

  return metaData;
};
export const createLiveEventMetadata = (startTime: Date | undefined, endTime: Date | undefined, locale: string) => {
  const metaData: { id: string; value: string }[] = [];
  const date = startTime ? formatLocalizedDateShort(startTime, locale) : '';
  const time = formatVideoScheduleTime(locale, startTime, endTime);

  // ids are needed to help components identify the type of metadata
  if (date) metaData.push({ id: 'date', value: date });
  if (time) metaData.push({ id: 'time', value: time });

  return metaData;
};

export const createVideoFormatMetadata = (media: PlaylistItem) => [media.videoFormat, media.audioFormat, media.subtitleFormat].filter(Boolean) as string[];

export const countListValues = (value: string) => (!value ? 0 : value.split(',').length);
